import { useQuery } from "@tanstack/react-query"
import { getBackofficeOrganizationQuery } from "modules/backoffice/lib/organizations/getBackofficeOrganizationQuery"

export function useGetBackofficeOrganizationQuery(
  ...args: Parameters<typeof getBackofficeOrganizationQuery>
) {
  return useQuery(getBackofficeOrganizationQuery(...args))
}
